var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8879_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.69751 13.4893C1.21368 13.4893 -0.000366211 14.7033 -0.000366211 16.1871V26.9786C-0.000366211 28.4625 1.21368 29.6765 2.69751 29.6765C4.18134 29.6765 5.39539 28.4625 5.39539 26.9786V16.1871C5.39539 14.7033 4.18134 13.4893 2.69751 13.4893Z",
    fill: "#10DD76"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3741 13.4893C30.8903 13.4893 29.6763 14.7033 29.6763 16.1871V26.9786C29.6763 28.4625 30.8903 29.6765 32.3741 29.6765C33.858 29.6765 35.072 28.4625 35.072 26.9786V16.1871C35.072 14.7033 33.858 13.4893 32.3741 13.4893Z",
    fill: "#10DD76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74438 13.4893V32.3744C6.74438 33.8582 7.95843 35.0723 9.44226 35.0723H10.7912V40.468C10.7912 41.9519 12.0052 43.1659 13.4891 43.1659C14.9729 43.1659 16.187 41.9519 16.187 40.468V35.0723H18.8848V40.468C18.8848 41.9519 20.0989 43.1659 21.5827 43.1659C23.0665 43.1659 24.2806 41.9519 24.2806 40.468V35.0723H25.6295C27.1133 35.0723 28.3274 33.8582 28.3274 32.3744V13.4893H6.74438Z",
    fill: "#10DD76"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3274 12.14C28.3274 9.44217 27.3831 7.14898 25.7644 5.26047L28.1925 1.07876C28.3274 0.808969 28.3274 0.404288 27.9227 0.1345C27.518 -0.135288 27.2482 -0.000393701 27.1133 0.404288L24.8202 4.31621C22.9316 2.4277 20.3687 1.34854 17.5359 1.34854C14.7031 1.34854 12.1401 2.4277 10.2516 4.18131L7.95843 0.404288C7.82354 -0.000393701 7.41885 -0.135288 7.14907 0.1345C6.87928 0.404288 6.60949 0.674075 6.87928 1.07876L9.30737 5.26047C7.68864 7.14898 6.74438 9.44217 6.74438 12.14H28.3274Z",
    fill: "#10DD76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.489 8.09338C14.234 8.09338 14.8379 7.48944 14.8379 6.74445C14.8379 5.99945 14.234 5.39551 13.489 5.39551C12.744 5.39551 12.14 5.99945 12.14 6.74445C12.14 7.48944 12.744 8.09338 13.489 8.09338Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5827 8.09338C22.3277 8.09338 22.9316 7.48944 22.9316 6.74445C22.9316 5.99945 22.3277 5.39551 21.5827 5.39551C20.8377 5.39551 20.2338 5.99945 20.2338 6.74445C20.2338 7.48944 20.8377 8.09338 21.5827 8.09338Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8848 35.0723L24.2805 40.468V35.0723H18.8848Z",
    fill: "#0CC15E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7911 35.0723L16.1869 40.468V35.0723H10.7911Z",
    fill: "#0CC15E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8879_308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.0724,
    height: 43.166,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIcon);
export default __webpack_public_path__ + "static/media/android_icon.92d10ffc1a4523ec3a480b0c049ac430.svg";
export { ForwardRef as ReactComponent };